import { TrivialError } from 'app/core/error/error';
import { Globals } from 'app/core/globals';
import { ConditionConfig } from 'collage-designer/collage-designer-config';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';

export class InvalidConditionError extends TrivialError
{
  protected _name: string = 'InvalidConditionError';
}

export class ConditionMatcher
{
  private catalogStoreId: string;
  private designStepService: DesignStepService;

  private partOrientationMapping: {[partName: string]: string} = {};

  public constructor(
      catalogStoreId: string,
      designStepService: DesignStepService)
  {
    this.catalogStoreId = catalogStoreId;
    this.designStepService = designStepService;
  }

  public async determinePartOrientationMapping(): Promise<void>
  {
    this.partOrientationMapping = {};
    for (const partLocation of this.designStepService.getPartLocations()) {
      let orientation = await this.getPartOrientation(
          partLocation.part.id, partLocation.designStepId);

      if (orientation) {
        this.partOrientationMapping[partLocation.part.id] = orientation;
      }
    }
  }

  public isConditionFullfilled(condition: ConditionConfig): boolean
  {
    let pattern = undefined;
    const partName = condition.part;

    switch (condition.type) {
      case 'part_is_landscape':
        return this.partOrientationMapping[partName] === 'landscape';
      case 'part_is_portrait':
        return this.partOrientationMapping[partName] === 'portrait';
      case 'store_matches':
        pattern = new RegExp(condition.value.replace('*', '.*'));
        return pattern.test(this.catalogStoreId);
      case 'store_does_not_match':
        pattern = new RegExp(condition.value.replace('*', '.*'));
        return !pattern.test(this.catalogStoreId);
      case 'mode_is':
        return condition.value === Globals.mode;
      case 'is_available':
        return condition.value === 'yes';
      default:
        throw new InvalidConditionError(`condition ${condition.type} unknown`);
    }
  }

  private async getPartOrientation(
      partName, designStepId): Promise<string | undefined>
  {
    const structure = await this.designStepService.getSVGStructureByPartId(
        partName, designStepId);
    if (!structure) {
      return undefined;
    }

    const doc = (new DOMParser()).parseFromString(structure, 'image/svg+xml');
    const width =
        parseFloat((<HTMLElement> doc.firstChild).getAttribute('width'));
    const height =
        parseFloat((<HTMLElement> doc.firstChild).getAttribute('height'));

    return width > height ? 'landscape' : 'portrait';
  }
}



// WEBPACK FOOTER //
// ./src/app/collage-designer/design-step/condition-matcher.ts